var COLORS = {
    teal: '#20c997',
    black: '#212121',
    trueBlack: '#000000',
    purple: '#665691',
    pink: '#e83e8c',
    red: '#d53e39',
    orange: '#f0ad4e',
    yellow: '#ffc107',
    green: '#1b7921',
    blue: '#2177d4',
    indigo: '#30349f',
    turquoise: '#a4edd9',
    cyan: '#5bc0de',
    lemon: '#fcea9f',
    coral: '#e95d52',
    greenLight: '#5bb75d',
    redLight: '#fff6f6',
    redDark: '#463c45',
    blueLight: '#f4f9fe',
    blueDark: '#344456',
    purpleLight: '#a290d3',
    goldenrod: '#e95d52',
    newOrange: '#E74011',
    gray50: '#f9fafb',
    gray100: '#f3f6f9',
    gray200: '#eaeef5',
    gray250: '#e2e7f0',
    gray300: '#dae0eb',
    gray400: '#c5cede',
    gray500: '#a8b2c4',
    gray600: '#8a94a6',
    gray700: '#697384',
    gray750: '#5b6270',
    gray800: '#474d58',
    gray850: '#363c46',
    gray900: '#242e33',
    gray950: '#181e21',
    white: '#FFFFFF',
};
var COLORS_THEME = {
    primary: COLORS.coral,
    // primary: COLORS.newOrange,
    black: COLORS.gray900,
    secondary: COLORS.gray700,
    success: COLORS.green,
    info: COLORS.cyan,
    warning: COLORS.yellow,
    danger: COLORS.red,
    light: COLORS.gray100,
    dark: COLORS.gray800,
    white: COLORS.white,
};
export { COLORS, COLORS_THEME };
//# sourceMappingURL=index.js.map